export function initHeroVideo() {
	const heroButton = document.querySelector("[data-hero-button]");
	if (heroButton) {

		let heroVideo 	   = document.querySelector("[data-hero-video]");
		const heroContent  = document.querySelector("[data-hero-content]");
		const heroControls = document.querySelector("[data-current-video-controls]");
		const heroBtnSound = document.querySelector("[data-video-control-sound]");
		const heroBtnPlay  = document.querySelector("[data-video-control-play]");

		// Load hero here so it can start to download and buffer
		loadHerovideo("invisible");

		heroButton.addEventListener("click", function () {

			//console.log('clicked watch');

			heroContent.classList.add("opacity-0");

			heroVideo.classList.remove("invisible");
			heroControls.classList.remove("invisible");
			heroVideo.play();

			heroContent.addEventListener(
				"transitionend",
				// Arrow function?
				function (event) {

					//console.log('transition end');

					heroVideo.classList.remove("invisible");
					//heroVideo.classList.add("opacity-100");
					//heroVideo.setAttribute("autoplay", "");
					heroVideo.play();

					// Now add default attributes for playing and sound
					
					//heroControls.classList.add("opacity-100");
					heroControls.classList.remove("invisible");
					
				},
				{
					once: true,
				},
			);
		});


		/* Play / Pause */
		heroBtnPlay.addEventListener("click", function () {
			if(heroVideo.paused){
				heroVideo.play();
				heroBtnPlay.setAttribute('src', heroBtnPlay.getAttribute('data-img-off'));
			} else {
				heroVideo.pause();
				heroBtnPlay.setAttribute('src', heroBtnPlay.getAttribute('data-img-on'));
			}
		});


		/* Sound: on/off */
		heroBtnSound.addEventListener("click", function () {
			if(heroVideo.muted){
				heroVideo.muted = false;
				heroBtnSound.setAttribute('src', heroBtnSound.getAttribute('data-img-on'));
			} else {
				heroVideo.muted = true;
				heroBtnSound.setAttribute('src', heroBtnSound.getAttribute('data-img-off'));
			}
		});

		// Listen for the resize
		window.addEventListener('resize', function(event) {

			if(heroVideo.classList.contains("invisible")) { return false;}

			loadHerovideo();
			//if(reloaded==true){ heroVideo.play(); }
			//console.log('end resize');
		}, true);


		function loadHerovideo(invisible=""){
			//let heroVideo = document.querySelector("[data-hero-video]");
			let pciCurrentVideo = document.getElementById('pci-hero-video');
			let device = pciCurrentVideo.getAttribute('data-device');
			let pciVideoBreakpoint = 768;

			//if(heroVideo.classList.contains("invisible")) { return false;}

			let videoElement = "";
			let assetVideo   = "";

			// If we are in the break point aleady ignore the resize
			if( parseInt(screen.width) < pciVideoBreakpoint && device == 'mobile' ){ return false; }
        	if( parseInt(screen.width) >= pciVideoBreakpoint && device == 'desktop' ){ return false; }

			// Set the relevant device
			if( parseInt(screen.width) < pciVideoBreakpoint ){
				pciCurrentVideo.setAttribute('data-device', 'mobile');
				assetVideo = pciCurrentVideo.getAttribute('data-mobile');
			} else {
				pciCurrentVideo.setAttribute('data-device', 'desktop');
				assetVideo = pciCurrentVideo.getAttribute('data-desktop');
			}
	

			// Create the video element
			videoElement =  '<video data-hero-video disablePictureInPicture="" playsinline="" muted="" class="'+invisible+' absolute top-0 left-0 w-full h-full object-cover transition-opacity duration-200 ease-in-out">';
			videoElement += '<source src="'+assetVideo+'.mp4" type="video/mp4" />';
			videoElement += '<source src="'+assetVideo+'.webm" type="video/webm" />';
			videoElement += '<source src="'+assetVideo+'.ogv" type="video/ogg" />';
			videoElement += '</video>';
	

			// Set the video element
			pciCurrentVideo.innerHTML = videoElement;

			// Refresh the hero video?
			heroVideo = document.querySelector("[data-hero-video]");
			
			if(invisible!="invisible"){
				heroVideo.play();
			}

			//console.log('end load');
			return true;
		}

	}
}
